module.exports = __webpack_public_path__ + "static/_rents-a4e58b67251e1cbe3a9e0dc82afaa891.jpg";